export default "__VITE_ASSET__CZ8W0RDQ__"